export default __webpack_public_path__ + "static/media/gallery-1-4.f5dab769.webp";